import React from 'react';
import { changeIdeaReportID, powerBIBase } from '../../../config/PowerBiReportConfig';
import { appBaseURL } from '../../../config/URLConfig';

export const ChangeIdeaReport = ({ username }) => {

    const handleViewReportClick = () => {
        window.open(`${powerBIBase}${changeIdeaReportID}/ReportSection`);
    }

    const handleDownloadExcelClick = () => {
        window.open(`${appBaseURL}/api/change-idea-report?username=${username}`);
    }

    return (
        <div>
            <h2 className="report-header">Change Idea Report</h2>
            <div className="report-button-container">
                <div className={"report-button"} onClick={handleViewReportClick}>
                    Change Idea Report
                </div>
                <div className={ 'report-button' } onClick={ handleDownloadExcelClick }>
                    Download Excel
                </div>
            </div>
        </div>
    );
}
